import React, { useEffect } from "react";
import "@assets/css/components/Home/style.css";
import "react-circular-progressbar/dist/styles.css";

import { Accordion, Button, Card, Col, Container, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { Carousel as ReactCarousel } from "react-responsive-carousel";

import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import { useContext } from "react";
import UserContext from "@context/User/UserContext";
import multiViewComponentsPaths from "@helpers/multiViewComponentsPaths/multiViewComponentsPaths";
import { getUltimaLeccionTomada } from "@helpers/httpRequests/httpRequestsLecciones/httpRequestsLecciones";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faQuestion } from "@fortawesome/free-solid-svg-icons";
import useWindowResize from "@customHooks/useWindowResize";
import RecomendacionesIntereses from "@components/general/RecomendacionesIntereses/RecomendacionesIntereses";
import AtajosUsuarioEstudiante from "../components/AtajosUsuarioEstudiante";

import { Avatar, List, ListItem, ListItemAvatar, ListItemText, Rating, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { getAgendasAsesoriasPublicas } from "@helpers/httpRequests/httpRequestAgendaAsesorias/httpRequestAgendaAsesorias";
import confetti from "canvas-confetti";
import { ModalSweetAlert } from "@components/general/Alertas/Alertas";
import { ModalNotificacion } from "../modales/ModalNotificacion";
import { getDatosUsuario, renovarLicencia, updateFechaUltimoAcceso } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import getUnixTimestamp from "@helpers/dates/getUnixTimestamp/getUnixTimestamp";
import ReactStars from "react-rating-stars-component";
import ListadoCursos from "@components/general/Cursos/ListadoCursos";
import SplitText from "@helpers/animated/SplitText";
import SeccionSliderHome from "../components/SeccionSliderHome";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import { getCursos } from "@helpers/httpRequests/httpRequestsCursos/httpRequestsCursos";
import { useTranslation } from "react-i18next";
import { retrievePaymentIntent } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import { getDatosSegundoUsuario } from "@helpers/httpRequests/httpRequestsUsuarios/estudiantes/httpRequestsEstudiantes";
import numberCommaSeparator from "@helpers/formateoPrecios/numberCommaSeparator";
import { enviarComprobanteRenovacion } from "@helpers/httpRequests/httpRequestsMailers/httpRequestsMailers";
import { NotificationManager } from "react-notifications";


defineElement(lottie.loadAnimation);

const percentage = 66;

const SeccionPrincipalHome = ({language, handleChangeComponent, handleStartTour }) => {
	const {t} = useTranslation();
		
	const {
		size: { width },
	} = useWindowResize();

	const [ultimaLeccion, setUltimaLeccion] = useState(null);

	const [agendasAsesorias, setAgendasAsesorias] = useState([]);

	const slides = [
		{
			image: (
				<div className="image-wrapper" style={{ margin: "0 auto" }}>
					<picture width="100%" height="100%">
						<source srcSet={`${require("@assets/images/recursos_mos/logo_excel.png")}`} />
						<Image className="imageMos" src={`${require("@assets/images/recursos_mos/logo_excel.png")}`} alt="Imagen de slide" />
					</picture>
				</div>
			),
			title: t("MOS title"),
			subtitle:
				t("MOS description"),
			control: (
				<Button
					onClick={() => {
						handleChangeComponent("cursoPropedeuticoMos");
					}}
					className="mt-3 btn-sm btn-responsive">
					{t("Clic here")}
				</Button>
			),
		},
		{
			image: (
				<picture width="100%" height="100%">
					<source srcSet={`${require("@assets/images/recursos_mos/reseña_mos.webp")}`} />

					<source srcSet={`${require("@assets/images/recursos_mos/reseña_mos.png")}`} />
					<Image loading="lazy" className="img-fluid comentario-mos" src={`${require("@assets/images/recursos_mos/reseña_mos.webp")}`} alt="Imagen de slide" />
				</picture>
			),
		},
		{
			image: (
				<picture width="100%" height="100%">
					<source srcSet={`${require("@assets/images/recursos_mos/reseña_mos2.webp")}`} />

					<source srcSet={`${require("@assets/images/recursos_mos/reseña_mos2.png")}`} />
					<Image loading="lazy" className="img-fluid comentario-mos" src={`${require("@assets/images/recursos_mos/reseña_mos2.webp")}`} alt="Imagen de slide" />
				</picture>
			),
		},
		{
			image: (
				<picture width="100%" height="100%">
					<source srcSet={`${require("@assets/images/recursos_mos/reseña_mos3.webp")}`} />
					<source srcSet={`${require("@assets/images/recursos_mos/reseña_mos3.png")}`} />
					<Image loading="lazy" className="img-fluid comentario-mos" src={`${require("@assets/images/recursos_mos/reseña_mos3.webp")}`} alt="Imagen de slide" />
				</picture>
			),
		},
	];

	const { contextValue: userContextValue, setContextValue } = useContext(UserContext);


	const { usuarioLogeado, renovacion } = userContextValue;

	const { modalAniversarioVisto, setModalAniversarioVisto } = useState(false);

	const { nombreCompleto, idPerfil, rol, idPersona, folioContrato, nombreUsuario } = usuarioLogeado;

	const modalNotificacion = localStorage.getItem('modalNotificacionVista');

	const handleUltimaLeccion = (codigoLeccion) => {
		// console.log(ultimaLeccion);

		const codigoCurso = codigoLeccion.substring(0, 4);

		const codigoSeccionSeleccionada = codigoLeccion.substring(6, 0);

		// console.log("Ultima Leccion Vista: ", codigoLeccion);

		setContextValue({
			...userContextValue,
			codigoCursoSeleccionado: codigoCurso,
			ultimoCursoTomado: codigoCurso,
			codigoSeccionSeleccionada,
		});

		handleChangeComponent(multiViewComponentsPaths.curso);
	};

	const handleMaterialCapacitacion = () => {
		const { materialCapacitacion } = multiViewComponentsPaths;

		handleChangeComponent(materialCapacitacion);
	};

	const obtenerUltimaLeccionVista = async () => {
		try {
			const { data } = await getUltimaLeccionTomada(idPerfil);
			// console.log(data);
			if (Array.isArray(data)) {
				setUltimaLeccion(data[0].codigoLeccion);
			} else {
				setUltimaLeccion(data.codigoLeccion);
			}
		} catch (error) {
			console.log(error);
			setUltimaLeccion(null);
		}
	};

	const obtenerAgendasPublicas = async () => {
		try {
			console.log('Obteniendo asesorias publicas')
			const agendas = await getAgendasAsesoriasPublicas();

			setAgendasAsesorias(agendas);
		} catch (error) {
			console.log("error al obtener las agendas publicas: ", error);
		}
	};

	

	// const fire = (particleRatio, opts) => {

	// 	const count = 550,
	// 	defaults = {
	// 		origin: { y: 0.7 },
	// 	};


	// 	confetti(
	// 		Object.assign({}, defaults, opts, {
	// 		particleCount: Math.floor(count * particleRatio),
	// 		})
	// 	);

	// }

	const enviarComprobante = (datosComprobante, formValues, datosCompra, paymentMethod, paymentIntent) => {
		return new Promise(async (resolve, reject) => {
			try {

				const { folioContrato, nombre, apellidoPaterno, apellidoMaterno, correo } = formValues;

				const { metodoPago, precios } = datosCompra;

				const {
					card: { last4 },
				} = paymentMethod;

				const {
					id: paymentIntentId,
					// amount: montoCobro,
					payment_method_options: { card },
				} = paymentIntent;

				const titular = `${nombre.trim()} ${apellidoPaterno.trim()} ${apellidoMaterno.trim()}`;

				const replacements = {
					folioContrato,
					titular,
					numeroTarjeta: `Tarjeta con terminación ${last4}`,
					metodoPago: "De contado",
					description: `Renovación de Licencia Click+ Premium - Folio ${folioContrato}`,
					paymentIntentId,
					correo,
					montoCobro: numberCommaSeparator(datosComprobante.montoCobro / 100),
					costoBase:numberCommaSeparator(datosComprobante.montoCobro / 100),
					
				};

				await enviarComprobanteRenovacion(replacements);

				resolve();
			} catch (error) {
				console.log("Error al enviar el comprobante de compra: ", error);

				reject(error);
			}
		});
	};


	const procesarRenovacion = async () => {
		try {
			const { stripeSession } = renovacion;

			const { amount_total, payment_intent: paymentIntentId, metadata } = stripeSession;

			const { paymentIntent, paymentMethod } = await retrievePaymentIntent(paymentIntentId);

			const { id: folioPago, amount } = paymentIntent;

			const {
				card: { last4, funding },
			} = paymentMethod;

			const datosRenovacion = {
				folioContrato: usuarioLogeado.folioContrato,
				pagoDeContado: true,
				costoTotal: amount / 100,
				amortizacionesTotales: 1,
				montoPagado: amount / 100,
				montoQuincenal: amount / 100,
				metodoPago: 'contado',
				tipoTarjeta: funding,
				referenciaPago: paymentIntentId,
			};
			await renovarLicencia({
				folioContrato: metadata.folioContrato,
				datosRenovacion,
				idPersona,
				idCredencial: usuarioLogeado.idCredencial,
				idRegion: usuarioLogeado.idCodigoRegion,
				folioRenovacion: usuarioLogeado.folioRenovacion
			});

			const { data: datosUsuario } = await getDatosUsuario({
				tipoUsuario: usuarioLogeado.rol,
				idCredencial: usuarioLogeado.idCredencial,
				usuarioTitular: usuarioLogeado.usuarioTitular,
			});

			const [datosUsuarioActualizados] = datosUsuario;

			setContextValue({
				...userContextValue,
				usuarioLogeado: datosUsuarioActualizados,
				renovacion: undefined,
			});

			console.log("Enviando comprobante de renovacion");

			await enviarComprobante(
				{
					titular: `${usuarioLogeado.nombreCompleto} ${usuarioLogeado.apellidos}`,
					paymentIntentId: folioPago,
					folioContrato,
					montoCobro: amount,
					numeroTarjeta: `Tarjeta con terminación ${last4}`,
					description: `Renovación de Licencia Click+ - Folio ${folioContrato}`,
					correo: usuarioLogeado.correo,
				},
				{
					folioContrato,
					nombre: usuarioLogeado.nombreCompleto,
					apellidoPaterno: usuarioLogeado.apellidos.split(" ")[0],
					apellidoMaterno: usuarioLogeado.apellidos.split(" ")[0],
					correo: usuarioLogeado.correo
				},
				{ metodoPago: renovacion.metodoPago, precios: renovacion.precios },
				paymentMethod,
				paymentIntent
			);

			NotificationManager.success("¡Renovación efectuada con éxito!");

			// setTimeout(() => window.location.reload(), 1500);
		} catch (error) {
			console.log("Error al renovar la licencia: ", error);
		}
	};
		const [key, setKey] = useState("edoCuenta");
	

	const consultarPaymentIntent = async () => {
			try {
				const { paymentIntent } = await retrievePaymentIntent(renovacion.stripeSession.payment_intent);
				console.log(paymentIntent)
				if (paymentIntent.status === "succeeded") {
	
					setKey('dashboard');
	
					setContextValue({
						...userContextValue,
						renovacion: {
							...userContextValue.renovacion,
							pagoIniciado: false,
							pagoFinalizado: true
						}
					});
					NotificationManager.success('¡Pago de renovación aplicado!');
				}
			} catch (error) {
				console.log("errpr al consultar el payment intent: ", error);
			}
		};


	useEffect(() => {

		// if (renovacion) {
		// 	console.log("RENOVACION")
		// 		if (renovacion.pagoIniciado && renovacion.renovacionKueski === false) {
		// 			console.log('ENTRA EN EL IF DE LA RENOVACION')
		// 			consultarPaymentIntent();
		// 		}else if(renovacion.pagoFinalizado && renovacion.renovacionKueski === false){
		// 			procesarRenovacion();
		// 		}
		// 	}

		// if(modalNotificacion === null) {

		// 	fire(0.25, {
		// 		spread: 26,
		// 		startVelocity: 55,
		// 	  });

		// 	  fire(0.2, {
		// 		spread: 60,
		// 	  });

		// 	  fire(0.35, {
		// 		spread: 100,
		// 		decay: 0.91,
		// 		scalar: 0.8,
		// 	  });

		// 	  fire(0.1, {
		// 		spread: 120,
		// 		startVelocity: 25,
		// 		decay: 0.92,
		// 		scalar: 1.2,
		// 	  });

		// 	  fire(0.1, {
		// 		spread: 120,
		// 		startVelocity: 45,
		// 	  });

		// 	  setTimeout(async() => {
		// 		try {
		// 			await ModalSweetAlert({
		// 				html: <ModalNotificacion/>,
		// 				showConfirmButton: false,
		// 				showCloseButton: true,
		// 			});


		// 			} catch (error) {
		// 			console.log("Error al agregar una nueva lección: ", error);
		// 		}
		// 	}, 1000);
		// }




		// console.log('Entra en use effect de vista home principal')
		// mostrarNotificacion();

		const ultimoAcceso = getUnixTimestamp();

		const updateFechaAcceso = async () => {
			try {
				await updateFechaUltimoAcceso({
					idPersona: idPersona,
					fecha: ultimoAcceso,
				});
			} catch (error) {
				console.log(error);
			}
		}

		updateFechaAcceso();

		if (agendasAsesorias.length === 0) {
			obtenerAgendasPublicas();
		}

		obtenerUltimaLeccionVista();

	}, []);

	// const handleAnimationComplete = () => {
	// 	console.log("Finaliza la animacion")
	// }

	// useEffect(() => {
	// 	if (renovacion) {
	// 		console.log("RENOVACION")
	// 			if (renovacion.pagoIniciado && renovacion.renovacionKueski === false) {
	// 				console.log('ENTRA EN EL IF DE LA RENOVACION')
	// 				consultarPaymentIntent();
	// 			}else if(renovacion.pagoFinalizado && renovacion.renovacionKueski === false){
	// 				procesarRenovacion();
	// 			}
	// 		}
	// }, [renovacion])

	return (
		<>
			<Container fluid className="p-0 mt-4 mb-3 podria-interesar-container">
				<Row className="justify-content-between mt-5">
					<Col className="col-12 col-lg-9 mb-5 text-center text-md-start">

					<SplitText
						text={`${t('Welcome title')}${nombreCompleto}!`}
						delay={25}
						animationFrom={{ opacity: 0, transform: 'translate3d(0,50px,0)' }}
						animationTo={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
						easing="easeOutCubic"
						threshold={0.2}
						rootMargin="-50px"
						// onLetterAnimationComplete={handleAnimationComplete}
						width={width}
						modoOscuro={usuarioLogeado.modoOscuro}
						/>

						{/* // ) : (
						// 	<span style={{ fontSize: "1.3rem" }}>
						// 		¡Hola {nombreCompleto}! Te damos la bienvenida a la plataforma{" "}
						// 		<b style={{ fontSize: "1.5rem" }}>
						// 			Click <span style={{ color: "rgb(245, 158, 11)" }}>+</span>
						// 		</b>
						// 	</span>
						// )} */}
					</Col>

					{width >= 1200 && (
						<Col className="col-md-2 mb-4 " style={{ height: "0px" }}>


							{rol !== typesTiposUsuario.gestion ? (
								<>
									{/* <OverlayTrigger placement={"top"} overlay={<Tooltip>Conoce tu entorno</Tooltip>}>
										<Button onClick={handleStartTour} className="btn btn-primary mx-2">
											<FontAwesomeIcon className="mx-2 pointer question" style={{ fontSize: "1.8rem" }} icon={faQuestion} />
										</Button>
									</OverlayTrigger> */}
									<OverlayTrigger placement={"top"} overlay={<Tooltip>{t('Get the user manual')}</Tooltip>}>
										<a
											className="btn btn-primary mx-2"
											style={{ textDecoration: "none" }}
											label="Descargar PDF"
											href={rol === "asesor" ? "https://globalclickmexico.com/item/Manual para asesor Click+.pdf" : "https://globalclickmexico.com/item/Manual de usuario Click+.pdf"}
											target="_blank"
											rel="noreferrer"
										>
											<FontAwesomeIcon className="mx-2 pointer question" style={{ fontSize: "1.8rem" }} icon={faDownload} />
										</a>

									</OverlayTrigger>
								</>
							): null}
						</Col>
					)}
				</Row>

				<Row className="justify-content-center justify-content-md-start text-center mb-5 p-4 contenedor-lordicons">
					<AtajosUsuarioEstudiante handleChangeComponent={handleChangeComponent} handleUltimaLeccion={handleUltimaLeccion} ultimaLeccion={ultimaLeccion} rol={rol} nombreUsuario={nombreUsuario} />
				</Row>

				{rol !== typesTiposUsuario.gestion ? (
					<Row>
						<Col>
							<RecomendacionesIntereses handleChangeComponent={handleChangeComponent} />
						</Col>
					</Row>
				):null}

				<TitleDashboard title='Te podria interesar' className="interes mt-4" />

				{rol !== typesTiposUsuario.gestion ? (
					<Row className="podria-interesar mt-4 mb-0 mb-md-5">
						<Col className={`col-12 columna-mos col-lg-5`}>
							<div className="contenedor-mos">
								<div className="contenedor-carrusel">
									<ReactCarousel interval={5000} showArrows={false} showStatus={false} showThumbs={false} swipeable={true} emulateTouch={true} infiniteLoop={true} autoPlay={false}>
										{slides.map((slide, key) => (
											<div className="contenido-mos" key={key}>
												{slide.image}

												<h6 className="mt-2">{slide.title}</h6>

												<div className="m-2 slide-subtitle">{slide.subtitle}</div>

												{slide.control}
											</div>
										))}
									</ReactCarousel>
								</div>
							</div>
						</Col>

						<Col className={`col-12 columna-capacitacion col-lg-7`}>
							<div className="parallax contenedor-material-capacitacion mt-3 mt-md-0">
								<div className="text-container">
									<div className="parallax-text">
										<h2>{t('Material seen in training')}</h2>

										<Button onClick={handleMaterialCapacitacion} className="btn-responsive" variant="warning">
											{t("See material")}
										</Button>
									</div>
								</div>
							</div>
						</Col>


					</Row>
				): null}


				{rol === typesTiposUsuario.gestion ? (
					<Row className="podria-interesar mt-4 mb-0 mb-md-5">
						

						<Col className={`col-12 columna-capacitacion`}>
							<div className="parallax contenedor-material-capacitacion mt-3 mt-md-0">
								<div className="text-container">
									<div className="parallax-text">
										<h2>{t('Material seen in training')}</h2>

										<Button onClick={handleMaterialCapacitacion} className="btn-responsive" variant="warning">
											{t('See material')}
										</Button>
									</div>
								</div>
							</div>
						</Col>


					</Row>
				): null}

				

				{rol !== typesTiposUsuario.gestion ? (
					<Row className={`podria-interesar mt-0 ${agendasAsesorias.length > 0 ? 'mt-md-5 mb-5' : 'mt-0 mb-0' }`}>
						{/* Seccion para mostrar las agendas de asesorias que son publicas. */}
						{agendasAsesorias.length > 0 ? (
								<>
								<Col className={`col-12 columna-capacitacion col-lg-7 `}>
									<div className="contenedor-feedback-fondo contenedor-material-capacitacion mt-3 mt-md-0">
										<div className="text-container">
											<div className="parallax-text">
												<h2>{t('Reviews from our customers')}</h2>

												<h4>{t('Reviews description')}</h4>
											</div>
										</div>
									</div>
								</Col>

								<Col className={`col-12 columna-mos col-lg-5 mt-5 mt-lg-0`}>
									<div className="contenedor-feedback-inicio">
										<div className=" feedbacks shadow-lg">
											<ReactCarousel interval={5000} showArrows={false} showStatus={false} showThumbs={false} swipeable={true} emulateTouch={true} infiniteLoop={true} autoPlay={false}>
												{agendasAsesorias.map((item, key) => (
													<div className="pt-0" key={key}>
														<Row className="justify-content-center h-100">
															<Col className="col-auto text-center">
																<div style={{ background: "#fff", borderRadius: 10 }} className="m-5 p-3 shadow-lg">

																	<ListItemAvatar className="mb-2" >
																		<Avatar style={{ margin: '0px auto' }} sx={{ width: 75, height: 75 }}>
																			<AccountCircleIcon sx={{ fontSize: 60 }} />
																		</Avatar>
																	</ListItemAvatar>

																	<Row className="text-center justify-content-center">
																		<Col className="col-12">
																			
																			<h4 className="mt-2">{language === 'es' ? `Asesoría en ${item.temaElegido}` : `${item.temaElegido} advice`}</h4>

																			<span className="mb-2" style={{ color: '#000', fontWeight: 'bold', fontStyle: 'italic' }}>"{item.feedback}"</span>

																			<p className="mt-4"><small>{`${item.nombreCompleto} ${item.apellidos}`}</small></p>
																		</Col>
																		<Col className="col-auto">
																			<ReactStars count={5} edit={false} value={item.calificacion} size={35} activeColor="#ff9900" />
																		</Col>
																	</Row>

																</div>
															</Col>
														</Row>
													</div>
												))}
											</ReactCarousel>
										</div>
									</div>
								</Col>
								</>
						) : null}
					</Row>
				): null}

				
			
			</Container>

		</>

	);
};

export default SeccionPrincipalHome;
